<!--suppress ES6ModulesDependencies -->
<template>
    <div>
        <ResumoContrato v-if="m_tela === RESUMO" :value="value" @input="$listeners.input" @nextPage="irParaAssinatura()" @prevPage="$listeners.prevPage" @finalizado="$listeners.finalizado" />
        <AssinaturaContrato v-if="m_tela === SELECIONAR_ASSINATURA" :value="value" @input="$listeners.input" @nextPage="$listeners.nextPage" @prevPage="irParaResumo()" @finalizado="$listeners.finalizado" />
    </div>
</template>

<script>
  import ResumoContrato from './ResumoContrato'
  import AssinaturaContrato from './AssinaturaContrato'

  export default {
    name: 'Contrato',
    components: { ResumoContrato, AssinaturaContrato },
    props: { value: Object, tela: { type: String, validators: ['selecionar_resumo', 'selecionar_assinatura'] } },
    data: () => ({
      m_tela: ''
    }),
    computed: {
      SELECIONAR_ASSINATURA: () => 'selecionar_assinatura',
      RESUMO: () => 'selecionar_resumo'
    },
    watch: {
      tela (val) {
        this.m_tela = val
      }
    },
    mounted () {
      this.m_tela = this.tela || this.RESUMO
    },
    methods: {
      reload (reload) {
        this.$emit('reload', reload)
      },
      irParaAssinatura () {
        this.m_tela = this.SELECIONAR_ASSINATURA
      },
      irParaResumo () {
        this.m_tela = this.RESUMO
      }
    }
  }
</script>

<style scoped>
</style>
